const padDatePart = (value) => String(value).padStart(2, '0');

export function formatLogDateTime(date) {
  return [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join('-') + ' ' + [
    padDatePart(date.getHours()),
    padDatePart(date.getMinutes()),
    padDatePart(date.getSeconds()),
  ].join(':');
}

export function startOfNextLocalDay(date) {
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  nextDay.setHours(0, 0, 0, 0);
  return nextDay;
}

export function createDefaultLogTimeRange(now = new Date()) {
  const startBasis = new Date(now);
  startBasis.setMonth(startBasis.getMonth() - 1);
  return [
    formatLogDateTime(startOfNextLocalDay(startBasis)),
    formatLogDateTime(startOfNextLocalDay(now)),
  ];
}

export function createRecentLogTimeRange(now = new Date(), hours = 1) {
  const endTime = new Date(now);
  const startTime = new Date(endTime.getTime() - hours * 60 * 60 * 1000);
  return [
    formatLogDateTime(startTime),
    formatLogDateTime(endTime),
  ];
}
